<template>
  <div class="teacher-container">
    <el-form-item label="服务老师：">
      <div class="teacher-wrap">
        <el-tabs v-model="teacherTabKey" @tab-click="handleTabChange">
          <el-tab-pane label="随堂老师" v-if="content.type == 1" name="1"></el-tab-pane>
          <el-tab-pane label="售前老师" name="2"></el-tab-pane>
          <el-tab-pane label="售后老师" name="3"></el-tab-pane>
        </el-tabs>
        <div class="teacher-list">
          <el-table
            :data="teachers"
            border
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="id"
              label="ID"
              width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              min-width="160"
              align="center">
            </el-table-column>
            <el-table-column
              prop="avatar"
              label="头像"
              min-width="160"
              align="center">
              <template slot-scope="scope">
                <img class="avatar" :src="scope.row.avatar">
              </template>
            </el-table-column>
            <el-table-column
              prop="mobile"
              label="手机号"
              min-width="160"
              align="center">
            </el-table-column>
            <el-table-column
              prop="wechat"
              label="微信号"
              min-width="160"
              align="center">
            </el-table-column>
            <el-table-column
              label="操作"
              width="160"
              align="center"
              fixed="right">
              <template slot-scope="scope">
                <el-button
                  circle
                  size="mini"
                  icon="el-icon-top"
                  :disabled="scope.$index == 0"
                  @click="handleSortChange(scope.row, 'up')"
                ></el-button>
                <el-button
                  circle
                  size="mini"
                  icon="el-icon-bottom"
                  :disabled="scope.$index == teachers.length-1"
                   @click="handleSortChange(scope.row, 'down')"
                ></el-button>
                <el-button
                  circle
                  size="mini"
                  icon="el-icon-close"
                  @click="handleTeacherRemove(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button class="add-btn" type="primary" plain size="mini" @click="handleTeacherChoose">添加老师</el-button>
        </div>
      </div>
    </el-form-item>
    <TeacherChoose :visible="teacherChooseDialog" @close="teacherChooseDialog = false" @submit="saveTeacher"></TeacherChoose>
  </div>
</template>

<script>
import TeacherChoose from '@/components/dialog/teacher/TeacherChoose'

export default {
  name: "teacher",
  components: {
    TeacherChoose
  },
  props: {
    content: {
      type: Object,
      default: () => {return {}}
    }
  },
  watch: {
    content(val) {
      if (val) {
        if (val.teachers) {
          this.teacherAll = val.teachers

          // 数据区分
          this.computeTabTeacher()
        }
      }
    }
  },
  data() {
    return {
      teacherChooseDialog: false,
      teacherTabKey: this.content.type == 1 ? '1' : '2',
      teacherAll: this.content.teachers || [],
      teachers: [],
    }
  },
  methods: {
    // tab切换
    handleTabChange(val) {
      this.teacherTabKey = val.name

      // 数据区分
      this.computeTabTeacher()
    },
    handleTeacherChoose() {
      this.teacherChooseDialog = true
    },
    handleTeacherRemove(item) {
      this.teacherAll = this.teacherAll.filter(v => v.id != item.id || v.type != item.type)
      // 数据区分
      this.computeTabTeacher()

      this.$emit('save', {teachers: this.teacherAll})
    },
    // 排序位置变化
    handleSortChange(row, type) {
      const list = this.teachers
      const index = list.findIndex(v => v.id == row.id)
      list.splice(index, 1)
      if (type == 'up') {
        list.splice(index-1, 0, row)
      } else if (type == 'down') {
        list.splice(index+1, 0, row)
      }
      list.forEach((item, sort) => {
        item.sort = sort
      })
      this.teacherAll.forEach(item => {
        const exist = list.find(v => v.id == item.id && v.type == item.type)
        if (exist) {
          item.sort = exist.sort
        }
      })

       // 数据区分
      this.computeTabTeacher()

      this.$emit('save', {teachers: this.teacherAll})
    },
    saveTeacher({teachers}) {
      const res = this.teacherAll
      teachers.forEach(item => {
        const val = {...item, type: Number(this.teacherTabKey), sort: res.length}

        const exist = res.find(v => v.type == val.type && v.id == val.id)
        if (!exist) {
          res.push(val)
        }
      })

      this.teacherAll = res

      // 数据区分
      this.computeTabTeacher()

      this.$emit('save', {teachers: this.teacherAll})
    },
    computeTabTeacher() {
      const list = this.teacherAll.filter(v => v.type == this.teacherTabKey)
      list.sort((a, b) => a.sort - b.sort)
      this.teachers = list
    }
  }
};
</script>

<style scoped lang="less">
.teacher-container {

  .teacher-list {

    .avatar {
      display: block;
      width: 48px;
      height: 48px;
      object-fit: cover;
      margin: 0 auto;
    }
  }

  .add-btn {
    margin-top: 10px;
  }

  /deep/ .el-table th {
    background-color: #fff !important;
    padding: 5px 0;
  }
}
</style>
